

















































































import Vue from 'vue';
import _ from 'lodash';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { Action, Getter } from 'vuex-class';
import store from '@/store';
import { Menu, MenuItem } from '@/types/menus';
import MenuItemEditor from '@/components/Menu/MenuItemEditor.vue';
import { VueNestable, VueNestableHandle } from 'vue-nestable';

@Component({
  components: { MenuItemEditor, VueNestable, VueNestableHandle },
})
export default class MenuEditor extends Vue {
  @Prop() id!: string;
  @Getter('menus/menus') menus!: Menu[];
  @Getter('menus/selectedMenu') menu!: Menu;
  @Action('notifications/addNotification') addNotification!: Function;

  get pageName() {
    return (
      _.startCase(this.$route.name) +
      (this.menu.title ? ': ' + this.menu.title : '')
    );
  }

  async beforeRouteEnter(
    to: Route,
    from: Route,
    next: Function,
  ): Promise<void> {
    if (to.params.id !== 'undefined') {
      await store.dispatch('menus/getMenu', to.params.id);
    }
    next();
  }

  async beforeRouteUpdate(
    to: Route,
    from: Route,
    next: Function,
  ): Promise<void> {
    if (to.params.id !== 'undefined') {
      await store.dispatch('menus/getMenu', to.params.id);
    }
    next();
  }

  get menuTitle() {
    return this.menu.title;
  }

  set menuTitle(value) {
    this.menu.title = value;
    this.menu.name = _.kebabCase(value);
  }

  async saveNewMenu() {
    await store.dispatch('menus/saveMenu', this.menu);
    this.addNotification({
      text: 'Menu saved',
      colour: 'green',
      top: true,
      right: true,
    });
  }

  @Watch('menu.id')
  onMenuIdChanged(id?: string, oldId?: string) {
    if (id && oldId === undefined) {
      this.$router.replace({ name: 'edit-menu', params: { id } });
    }
  }

  @Watch('menu.items')
  onMenuItemsChanged(value?: any[], oldValue?: any[]) {
    if (!_.isEqual(value, oldValue)) {
      const update = _.map(value, function(item: MenuItem) {
        return {
          id: item.id,
          children: _.map(item.children, function(child: MenuItem) {
            return { id: child.id };
          }),
        };
      });
      store.dispatch('menus/saveMenuItemOrder', update);
    }
  }
}
